import { APP_CONTEXT } from '@reducers/app/types';
import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const createInitialFilters = () => ({
    seniority: [],
    department: [],
    email: [],
    location: [],
});
const initialState = {
    [APP_CONTEXT.PROSPECT]: createInitialFilters(),
    [APP_CONTEXT.SEARCH]: createInitialFilters(),
};
const slice = createSlice({
    name: 'SELECTED_FILTERS',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        /** Replaces one filter category with the user's new selection. */
        setFilter(state, { payload }) {
            const filters = state[payload.context];
            if (payload.type === 'location') {
                filters.location = payload.filters;
            }
            else {
                filters[payload.type] = payload.filters;
            }
        },
        /** Drops every filter of one context — "Clear all", and whenever a search restarts. */
        reset(state, { payload }) {
            state[payload.context] = createInitialFilters();
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
